/* Generated by scripts/generate-push-schema.ts. Do not edit manually. */
import { z } from 'zod';

export const pushNotificationNavigation = z.object({
  channelId: z.string().uuid(),
  messageId: z.string().uuid(),
  threadId: z.union([z.string().uuid(), z.null()]),
  type: z.literal('channel'),
});

export const pushNotificationData = z.object({
  navigation: z
    .union([
      z.null(),
      z.object({
        channelId: z.string().uuid(),
        messageId: z.string().uuid(),
        threadId: z.union([z.string().uuid(), z.null()]),
        type: z.literal('channel'),
      }),
    ])
    .optional(),
  notificationId: z.string().uuid(),
  recipientId: z.union([z.string(), z.null()]).optional(),
  senderProfilePictureUrl: z.union([z.string(), z.null()]).optional(),
});
